import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { DataNotFoundImage } from "../../assets/images";

const DataNotFound = () => (
  <div className="flex flex-col items-center justify-center h-full">
    <div className="w-56">
      <LazyLoadImage
        width="100%"
        height="100%"
        src={DataNotFoundImage}
        alt="Data Not Found"
      />
    </div>
    <p className="mt-2 text-xl font-medium text-center">Data Not Found</p>
  </div>
);

export default DataNotFound;
